import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, getResetByTag, utilityStyles } from './../../../styles';
import StyledLabel from '../../label/label.styles.js';
import StyledLabelOptional from '../../label/styles/label.optional.styles.js';
import StyledButtonGroup from '../button-group.styles';
var defaultStyles = function defaultStyles(_ref) {
  var isInverse = _ref.isInverse;
  if (isInverse) {
    return /*#__PURE__*/css("color:", colors.white, ";", StyledLabel, ">span{color:", colors.white, ";}", StyledLabelOptional, "{color:", colors.blue_200, ";}", StyledButtonGroup, "{background-color:", colors.navy_400, ";}&:disabled{", StyledButtonGroup, "{background-color:", colors.coolGray_200, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
  }
};
var resetStyles = getResetByTag('fieldset');
var StyledButtonGroupFieldset = /*#__PURE__*/_styled('fieldset', process.env.NODE_ENV === "production" ? {
  target: "eg6o8br0"
} : {
  target: "eg6o8br0",
  label: "StyledButtonGroupFieldset"
})(resetStyles, defaultStyles, utilityStyles);
export default StyledButtonGroupFieldset;